import { createStore, applyMiddleware } from "redux";
import { combineReducers } from "redux";
import { userReducer } from "./reducers/userReducer";
import { questionReducer } from "./reducers/questionReducer";
import { composeWithDevTools } from "redux-devtools-extension";
import thunk from "redux-thunk";
import { loadingBarReducer } from "react-redux-loading-bar";
import { saveState } from "./localStorage";
import throttle from "lodash/throttle";
export let store:any = {};

const combinedReducers = combineReducers({
  userReducer,
  questionReducer,

  loadingBar: loadingBarReducer,
});
if (process.env.NODE_ENV === "development") {
  store = createStore(
    combinedReducers,
    composeWithDevTools(applyMiddleware(thunk))
  );
} else {
  store = createStore(combinedReducers, applyMiddleware(thunk));
}

store.subscribe(throttle(() => saveState(store.getState()), 1000));
